export const SANDBOX_COMPUTE_PROVIDER = 'sandboxes'

export function isSandboxComputeProvider(provider: string | undefined): boolean {
  return provider === SANDBOX_COMPUTE_PROVIDER
}

export function effectiveRemoteControlPolicyEnabled(
  remoteControlPolicyEnabled: boolean | undefined,
  computeProvider: string | undefined,
): boolean | undefined {
  if (isSandboxComputeProvider(computeProvider)) {
    return true
  }
  return remoteControlPolicyEnabled
}
